import ReactDOM from 'react-dom/client';
import './index.scss';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { LanguageContextProvider } from './context/language.context';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <LanguageContextProvider>
      <App />
    </LanguageContextProvider>
  </BrowserRouter>
);
